// extracted by mini-css-extract-plugin
export default {"checkBox":"DomainFields-checkBox__Vvcl4","checkBoxGroup":"DomainFields-checkBoxGroup__nwHvv"};